export const removeTabIndexAttribute = () => {
	const gatsbyFocusWrapper = document.getElementById("gatsby-focus-wrapper");
	if (gatsbyFocusWrapper) {
		gatsbyFocusWrapper.removeAttribute("tabIndex");
	}
};